import * as React from 'react';

const UnpublishedProductImage = ({ src , alt  })=>/*#__PURE__*/ React.createElement("img", {
        className: "unpublished-product-image",
        src: src,
        alt: alt
    })
;

export { UnpublishedProductImage };
//# sourceMappingURL=UnpublishedProductImage.js.map
